"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _coreParagraph = _interopRequireDefault(require("@vfuk/core-paragraph"));
var _coreContainerWithLabel = _interopRequireDefault(require("@vfuk/core-container-with-label"));
var _coreBaseProps = require("@vfuk/core-base-props");
var _coreThemes = require("@vfuk/core-themes");
var _CompareCheckbox = _interopRequireDefault(require("./components/CompareCheckbox"));
var _SingleColumnCard = _interopRequireDefault(require("./components/layout/SingleColumnCard"));
var _TwoColumnCard = _interopRequireDefault(require("./components/layout/TwoColumnCard"));
var _CardBuilder = _interopRequireDefault(require("./themes/CardBuilder.theme"));
var _CardBuilderContainerWithLabel = _interopRequireDefault(require("./themes/CardBuilderContainerWithLabel.theme"));
var Styled = _interopRequireWildcard(require("./styles/CardBuilder.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CardBuilder = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$current, _container$appearance;
  var children = _ref.children,
    dataAttributes = _ref.dataAttributes,
    dataSelectorPrefix = _ref.dataSelectorPrefix,
    id = _ref.id,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
    localTheme = _ref.localTheme,
    rightColumn = _ref.rightColumn,
    leftColumn = _ref.leftColumn,
    footerText = _ref.footerText,
    compareOptions = _ref.compareOptions,
    container = _ref.container,
    dividers = _ref.dividers,
    lineBreakSpacer = _ref.lineBreakSpacer,
    _ref$paddingLevel = _ref.paddingLevel,
    paddingLevel = _ref$paddingLevel === void 0 ? 2 : _ref$paddingLevel,
    _ref$inverse = _ref.inverse,
    inverse = _ref$inverse === void 0 ? false : _ref$inverse;
  // Constants
  var componentName = 'CardBuilder';
  var componentNameContainer = 'CardBuilderContainerWithLabel';
  var _ref2 = (_ref$current = ref === null || ref === void 0 ? void 0 : ref.current) !== null && _ref$current !== void 0 ? _ref$current : {},
    leftColumnRef = _ref2.leftColumnRef,
    rightColumnRef = _ref2.rightColumnRef;
  // Hooks
  var containerRef = (0, _react.useRef)(null);
  var cardBuilderTheme = (0, _coreThemes.useLocalTheme)(componentName, _CardBuilder["default"], localTheme);
  var containerTheme = (0, _coreThemes.useLocalTheme)(componentNameContainer, _CardBuilderContainerWithLabel["default"]);
  // List of Slots (Single Column Card Builder mode)
  var multipleSlots = children || rightColumn;
  // Optional Single Slot (Two Column Card Builder mode)
  var optionalSingleSlot = leftColumn;

  // Render Semantic Conditions
  var cardBuilderMode = Boolean(optionalSingleSlot) ? 'horizontal' : 'vertical';
  var canRenderHorizontalSlot = cardBuilderMode === 'horizontal' && optionalSingleSlot;
  var hasFootNote = Boolean(footerText);
  var hasCompareCheckbox = Boolean(compareOptions);

  // Container configurations
  var defaultContainerAppereance = (_container$appearance = container === null || container === void 0 ? void 0 : container.appearance) !== null && _container$appearance !== void 0 ? _container$appearance : appearance;
  var defaultContainerHighlight = container === null || container === void 0 ? void 0 : container.highlight;
  var _ref3 = inverse ? cardBuilderTheme.appearance[appearance].inverse : cardBuilderTheme.appearance[appearance],
    paragraphAppearance = _ref3.paragraphAppearance,
    inverseText = _ref3.inverseText;
  return /*#__PURE__*/_react["default"].createElement(Styled.CardBuilder, _extends({
    id: id,
    ref: containerRef
  }, dataAttributes, {
    "data-selector": (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    "data-component-name": componentName,
    theme: cardBuilderTheme
  }), /*#__PURE__*/_react["default"].createElement(_coreContainerWithLabel["default"], _extends({}, container, {
    highlight: defaultContainerHighlight,
    appearance: defaultContainerAppereance,
    localTheme: containerTheme,
    paddingLevel: 0,
    allowOverflow: false,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'container-with-label')
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Styled.CardBuilderInnerGridCompositionRoot, {
    layoutMode: cardBuilderMode
  }, canRenderHorizontalSlot && /*#__PURE__*/_react["default"].createElement(_TwoColumnCard["default"], {
    ref: leftColumnRef,
    paddingLevel: paddingLevel,
    slot: leftColumn,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'two-column-card')
  }), /*#__PURE__*/_react["default"].createElement(_SingleColumnCard["default"], {
    ref: rightColumnRef,
    paddingLevel: paddingLevel,
    dividers: dividers,
    lineBreakSpacer: lineBreakSpacer,
    slots: multipleSlots,
    layoutMode: cardBuilderMode,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'single-column-card')
  })), hasCompareCheckbox && /*#__PURE__*/_react["default"].createElement(_CompareCheckbox["default"], {
    appearance: appearance,
    compareOptions: compareOptions,
    containerRef: containerRef,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'compare-checkbox')
  }))), hasFootNote && /*#__PURE__*/_react["default"].createElement(Styled.CardBuilderFooterTextWrapper, {
    cardBuilderTheme: cardBuilderTheme,
    appearance: appearance
  }, /*#__PURE__*/_react["default"].isValidElement(footerText) && typeof footerText !== 'string' ? footerText : /*#__PURE__*/_react["default"].createElement(_coreParagraph["default"], {
    size: 1,
    inverse: inverseText,
    appearance: paragraphAppearance,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, 'footer-text')
  }, footerText)));
});
var _default = CardBuilder;
exports["default"] = _default;
//# sourceMappingURL=CardBuilder.js.map